export const faqs = [
  {
    question: '如何观看视频？',
    answer: '您可以直接在本站浏览并观看所有视频内容，无需注册或下载任何软件。点击任意视频封面即可进入详情页面进行在线观看，支持全平台播放。',
  },
  {
    question: '视频画质如何？',
    answer: '本站所有视频均提供高清画质（1080P及以上），部分精选内容支持4K超高清。您可以根据网络状况自由切换清晰度，确保流畅的观看体验。',
  },
  {
    question: '视频内容是否免费？',
    answer: '本站绝大多数内容均为免费观看，部分独家精选内容可能需要会员权限。我们会持续更新大量优质免费内容，让更多用户享受到国产精品视频的魅力。',
  },
  {
    question: '如何搜索我想看的视频？',
    answer: '您可以使用首页顶部的搜索功能，输入关键词即可快速找到相关视频。同时，您也可以通过分类导航浏览不同类别的视频内容，如剧情、纪录、综艺、短片等。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '本站采用响应式设计，完美适配电脑、平板和手机等各类设备。无论您使用什么设备，都能获得优质的观看体验。',
  },
  {
    question: '视频多久更新一次？',
    answer: '我们每天都会更新新的视频内容，每周五更有大量精选内容上线。建议您关注我们的更新动态，不要错过任何精彩内容。',
  },
  {
    question: '如何联系我们？',
    answer: '您可以通过"关于我们"页面上的联系方式与我们取得联系，包括电子邮箱和在线客服。我们会在24小时内回复您的咨询。',
  },
];